import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import styles from './Report.module.scss';
import RiskControlFormSection from './components/RiskControlFormSection';
import RiskControlReportSection from './components/RiskControlReportSection';
import StatementReportSection from './components/StatementReportSection';
import StepperV2, {
  StepperV2Items,
} from '../../components/stepperv2/StepperV2';
import StepperV2Navigation from '../../components/stepperv2/StepperV2Navigation';

export interface ReportHandler {
  validChanged: (_: boolean) => void;
}

const ReportPage = () => {
  const navigate = useNavigate();

  const [formValid, setFormValid] = useState<boolean>(false);
  const [stepperItems] = useState<StepperV2Items[]>([
    {
      order: 0,
      number: 15,
      label: 'Risk Control Form',
      completed: false,
      src: '/icons/form.svg',
      element: <RiskControlFormSection validChanged={setFormValid} />,
    },
    {
      order: 1,
      number: 16,
      label: 'Risk Control Report',
      completed: false,
      src: '/icons/form.svg',
      element: <RiskControlReportSection validChanged={setFormValid} />,
    },
    {
      order: 2,
      number: 17,
      label: 'Statement Report',
      completed: false,
      src: '/icons/form.svg',
      element: <StatementReportSection validChanged={setFormValid} />,
    },
  ]);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const formMethods = useForm();

  // #region Methods
  const nextHandler = () => {
    if (!formValid) return;

    if (currentIndex < stepperItems.length - 1) {
      stepperItems[currentIndex].completed = true;
      setCurrentIndex((prev) => ++prev);
    }
  };
  const prevHandler = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => {
        let prevIndex = --prev;
        stepperItems[prevIndex].completed = false;

        return prevIndex;
      });
    } else {
      navigate('/risk-transfer?reverse');
    }
  };
  // #endregion Methods

  return (
    <FormProvider {...formMethods}>
      <StepperV2 items={stepperItems} currentStepIndex={currentIndex}>
        <div className={styles.sectionContainer}>
          {stepperItems[currentIndex].element}
        </div>
      </StepperV2>

      <StepperV2Navigation
        onPrev={prevHandler}
        onNext={nextHandler}
        nextDisabled={!formValid}
        isLast={currentIndex == stepperItems.length - 1}
      />
    </FormProvider>
  );
};

export default ReportPage;
